import { InjectionToken } from '@angular/core';

export const ACCOUNT_LABEL = new InjectionToken<string>('ACCOUNT_LABEL', {
  providedIn: 'root',
  factory: () => 'Account',
});
